import { useBreakpointValue } from "@chakra-ui/react"

export const useIsMobile = (): boolean => {
  return useBreakpointValue({ base: true, md: false }) ?? false
}
